import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingButton from '../common/LoadingButton';
import Header from '../common/Header';
import apiClient from '../../utils/apiClient';

const RedemptionSuccess = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);

    // Fetch user data to get is_staff status
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await apiClient.get('/api/users/profile/');
                setUserData(response.data);
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        };
        fetchUserData();
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
        navigate('/login');
    };

    const handleEditProfile = () => {
        navigate('/profile', { state: { openEditModal: true } });
    };

    return (
        <div className="pt-8 px-3">
            <Header 
                onEditProfile={handleEditProfile}
                onLogout={handleLogout}
                isStaff={userData?.is_staff}
            />
            
            <div className="container mx-auto px-8 py-8 max-w-4xl">
            <div className="text-center">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-popashot-blue mb-4">
                    <svg className="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                </div>
                <h1 className="mb-4">Registration Complete!</h1>
                <p className="mb-6">
                    Your Pop-A-Shot Elite has been successfully registered and is ready to play.
                </p>
            </div>

            <div className="bg-gray-50 rounded-lg p-6 mb-6">
                <h2 className="text-lg font-semibold text-popashot-blue mb-3">What's Next?</h2>
                <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start">
                        <span className="flex-shrink-0 h-5 w-5 text-popashot-blue mr-2">•</span>
                        <span>Access your <button onClick={async () => {
                            try {
                                await fetch(`${process.env.REACT_APP_API_URL}/api/users/admin-redirect/`, {
                                    method: 'GET',
                                    headers: {
                                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                                    },
                                    credentials: 'include'
                                });
                                window.location.href = `${process.env.REACT_APP_API_URL}/admin/machines/machine/`;
                            } catch (error) {
                                console.error('Failed to redirect to admin:', error);
                                alert('Failed to access dashboard. Please try logging in directly.');
                            }
                        }} className="text-popashot-blue-light hover:text-popashot-blue underline">dashboard</button> to view analytics and customize your Elite</span>
                    </li>
                    <li className="flex items-start">
                        <span className="flex-shrink-0 h-5 w-5 text-popashot-blue mr-2">•</span>
                        <span>Find FAQs, get assembly help, and learn ways to be a part of the Pop-A-Shot Community at the{' '}
                            <a
                                href="https://popashot.net/pages/pop-a-shot-elite-product-hub"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-popashot-blue-light hover:text-popashot-blue underline"
                            >
                                Pop-A-Shot Elite Product Hub
                            </a>
                        </span>
                    </li>
                </ul>
            </div>

            <div className="text-center space-y-4">
                <LoadingButton
                    onClick={async () => {
                        try {
                            // Make authenticated request to create Django session
                            await fetch(`${process.env.REACT_APP_API_URL}/api/users/admin-redirect/`, {
                                method: 'GET',
                                headers: {
                                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                                },
                                credentials: 'include' // Important: include cookies
                            });
                            // Redirect to admin panel
                            window.location.href = `${process.env.REACT_APP_API_URL}/admin/machines/machine/`;
                        } catch (error) {
                            console.error('Failed to redirect to admin:', error);
                            alert('Failed to access dashboard. Please try logging in directly.');
                        }
                    }}
                    className="btn-primary"
                >
                    Go to Dashboard
                </LoadingButton>
                
                <p className="mb-6">
                    <a
                        href="https://popashot.net/pages/pop-a-shot-elite-product-hub"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-popashot-blue-light hover:text-popashot-blue"
                    >
                        Visit Pop-A-Shot Elite Product Hub
                    </a>
                </p>
            </div>
            </div>
        </div>
    );
};

export default RedemptionSuccess;
